export const navigationES = {
  courses: 'Cursos',
  payments: 'Paquetes',
  classes: 'Clases'
}
